import {
  CLEAR_UNSAVED_CHANGES,
  SET_UNSAVED_CHANGES,
  type UnsavedChangesAction,
} from './actions'

export type UnsavedChangesState = {
  isDirty: boolean
}

export type State = UnsavedChangesState

export const initialState: State = {
  isDirty: false,
}

const reducer = (state: State = initialState, action: UnsavedChangesAction): State => {
  switch (action.type) {
    case SET_UNSAVED_CHANGES:
      return { ...state, ...action.payload }
    case CLEAR_UNSAVED_CHANGES:
      return initialState
    default:
      return state
  }
}

export default reducer
